<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-foreword element-with-heading" id="foreword">
<div class="heading heading-with-title heading-without-image" id="foreword-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Foreword</h1>
</div>
</div>
</div>
</div>
<div class="text" id="foreword-text">
<p class="first first-in-chapter first-full-width">This book is a work of fiction and was written before the invasion of Ukraine in February 2022. The Ukrainian people have nothing but my admiration and support.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// foreword.vue?5da5d0df